import { defineComponent as w, ref as l, reactive as y, provide as c, computed as d, onMounted as g, useCssModule as b, openBlock as D, createElementBlock as k, normalizeClass as C, renderSlot as x } from "vue";
import { debounce as A } from "lodash-es";
import $ from "../../utils/propValidator.mjs";
import p from "../../mixins/breakpoints.mjs";
import B from "./styles/CdrAccordionGroup.module.scss.mjs";
import E from "../../../_virtual/_plugin-vue_export-helper.mjs";
const U = w({
  name: "CdrAccordionGroup",
  props: {
    /**
     * A prop that will present accordion content as unwrapped. All content is expanded at the provided breakpoints.
     * @values @xs, @sm, @md, @lg, true
     */
    unwrap: {
      type: [String, Boolean],
      default: !1,
      validator: (e) => typeof e == "string" ? $(e, ["@xs", "@sm", "@md", "@lg"], !1) : typeof e == "boolean"
    }
  },
  setup(e) {
    const n = "cdr-accordion-group", t = l(0), r = l([]), u = l(null), a = y({
      isUnwrapped: !!e.unwrap
    });
    c("unwrap", a), c("grouped", !0);
    const s = d(() => {
      const o = t.value + 1;
      return o >= r.value.length ? 0 : o;
    }), i = d(() => {
      const o = t.value - 1;
      return o <= -1 ? r.value.length - 1 : o;
    }), f = (o) => {
      if (t.value === -1)
        return;
      const {
        key: m
      } = o;
      switch (m) {
        case "Home":
          o.preventDefault(), r.value[0].focus();
          break;
        case "End":
          o.preventDefault(), r.value[r.value.length - 1].focus();
          break;
        case "ArrowDown":
        case "Down":
          o.preventDefault(), r.value[s.value].focus();
          break;
        case "ArrowUp":
        case "Up":
          o.preventDefault(), r.value[i.value].focus();
          break;
      }
    }, v = (o) => {
      t.value = Array.prototype.indexOf.call(r.value, o.target);
    };
    return g(() => {
      r.value = u.value.querySelectorAll(".js-cdr-accordion-button"), typeof e.unwrap == "string" && (a.isUnwrapped = e.unwrap.indexOf(p()) !== -1, window.addEventListener("resize", A(() => {
        a.isUnwrapped = e.unwrap.indexOf(p()) !== -1;
      }, 300)));
    }), {
      style: b(),
      handleKeyDown: f,
      focusin: v,
      baseClass: n,
      accordionGroupEl: u
    };
  }
});
function h(e, n, t, r, u, a) {
  return D(), k("ul", {
    class: C(e.style[e.baseClass]),
    ref: "accordionGroupEl",
    onFocusin: n[0] || (n[0] = (...s) => e.focusin && e.focusin(...s)),
    onKeydown: n[1] || (n[1] = (...s) => e.handleKeyDown && e.handleKeyDown(...s))
  }, [x(e.$slots, "default")], 34);
}
const G = {
  $style: B
}, j = /* @__PURE__ */ E(U, [["render", h], ["__cssModules", G]]);
export {
  j as default
};
